import { render, staticRenderFns } from "./OpinionDefaultEdit.vue?vue&type=template&id=4cedea78&scoped=true"
import script from "./OpinionDefaultEdit.vue?vue&type=script&lang=js"
export * from "./OpinionDefaultEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cedea78",
  null
  
)

export default component.exports